// extracted by mini-css-extract-plugin
export default {"grid":"J2iyj","grid-5":"eddxN","img":"I0zF4","item":"oHGuP"};